<template>
    <div @click="createProject" class="add-project-card relative  flex cursor-pointer flex-col items-center justify-between  gap-x-7  overflow-hidden rounded-lg border border-eureka-200 p-8 hover:border-eureka-500">
        <div class="z-10 flex flex-col gap-2">
            <p class="flex items-center gap-2 text-lg font-semibold text-black">
                <PtIcon class="shrink-0 text-sm" icon="RightArrowBold"/>
                {{ t('emptyProjects.generateReport') }}
            </p>

            <p class="text-sm text-grey-450">
                {{ t('emptyProjects.analyzeTechBackground') }}
            </p>
        </div>

        <button class="th-btn th-btn-block">
            {{ t('quickStart')}}
        </button>

        <!-- <div class="add-project-bg absolute -right-1 top-0">
        </div> -->
    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz'
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import '@/assets/icons/rightArrowBold.svg'

const { t } = useI18n()
const router = useRouter()

function createProject() {
    router.push('chat');
}

</script>

<style lang="scss">
.add-project-card {
    background: linear-gradient(180deg, #FFF 0%, #DDEBF8 100%);
    &:hover {
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08), 0px 2px 6px 0px rgba(0, 0, 0, 0.08);
    }
}
</style>
